import {graphql} from 'react-apollo';

import {DELETE_ENTRY_MUTATION} from '../../queries';
import makeBlankEntry from './_makeBlankEntry.js';
import {
  applyOptimisticEntryToCache,
  buildSaveTimeEntry,
  buildSaveTimeVariables,
  pendingSaveKey
} from './_saveTimeHelpers';

export default graphql(DELETE_ENTRY_MUTATION, {
  props: ({
    ownProps: {
      setError,
      updateTimesheetData,
      setSavePending,
      queuePendingSave,
      timesheet,
      autoSave
    },
    mutate
  }) => ({
    deleteEntry({rowIndex, entryIndex, detailIndex = 0}) {
      const row = timesheet.rows[rowIndex];
      const entry = row.entries[entryIndex];

      // Auto-save OFF: queue a zero-hour save (Epicor treats hours=0 as a
      // delete) so the change is held locally and committed with the rest of
      // the batch when the user clicks Save.
      if (autoSave === false && queuePendingSave) {
        const built = buildSaveTimeEntry({
          timesheet,
          rowIndex,
          entryIndex,
          detailIndex,
          hours: 0
        });
        if (!built.skip) {
          applyOptimisticEntryToCache({
            updateTimesheetData,
            rowIndex,
            entryIndex,
            detailIndex,
            entry: built.entry,
            row: built.row
          });
          const key = pendingSaveKey({rowIndex, entryIndex, detailIndex});
          queuePendingSave({
            key,
            rowIndex,
            entryIndex,
            detailIndex,
            variables: buildSaveTimeVariables(timesheet, built.row, built.entry),
            entryDate: built.entry.Date
          });
        }
        return Promise.resolve();
      }

      // Auto-save ON: fire the delete mutation immediately.
      setSavePending({
        [entry.Date]: true,
        [entry.id]: true
      });
      return mutate({
        variables: {
          id: entry.Detail[detailIndex].id,
          company: timesheet.Company
        },
        update: store => {
          const detailOp = {
            $splice: [[detailIndex, 1]]
          };
          let entryUpdates = {};
          if (entry.Detail.length === 1) {
            // remove everything else on the entry, if there was only one detail
            entryUpdates = makeBlankEntry(timesheet, entryIndex);
          }
          updateTimesheetData(
            {
              rows: {
                [rowIndex]: {
                  entries: {
                    [entryIndex]: {
                      $merge: entryUpdates,
                      Detail: detailOp
                    }
                  }
                }
              }
            },
            store
          );
        }
      })
        .catch(err => {
          setError(err);
        })
        .then(() => {
          setSavePending({[entry.id]: false, [entry.Date]: false});
        });
    }
  })
});
